import Div from '@/shared/Div';
import Header from '@/shared/Header';
import Paragraph from '@/shared/Paragraph';
import PlanPrice, { PlanPriceProps } from './PlanPrice';
import classNames from 'classnames';
import RadioChecked from '../Icons/RadioChecked';
import RadioUnchecked from '../Icons/RadioUnchecked';
import { PLAN_BORDER_MAP } from '@/constants/amc';

interface PlanCardHeaderProps extends PlanPriceProps {
  title: string;
  subTitle: string;
  tier: string;
  isActive: boolean;
  discount?: boolean;
  expanded?: boolean;
}

const PlanCardHeader: React.FC<PlanCardHeaderProps> = ({
  title,
  subTitle,
  tier,
  isActive,
  discount,
  expanded,
  price,
  discountedPrice,
}) => {
  return (
    <Div
      className={classNames('px-4 py-5 rounded-t-cm flex justify-between', {
        [PLAN_BORDER_MAP[tier]]: isActive || expanded,
        'border-b': isActive || expanded,
        'pt-7': discount,
      })}
    >
      <Div className="flex gap-s3 items-start">
        <Div className="w-6 h-6">
          {isActive ? (
            <RadioChecked className={classNames('text-neutral-700')} />
          ) : (
            <RadioUnchecked />
          )}
        </Div>
        <Div className={classNames('flex flex-col gap-s2 text-neutral-700')}>
          <Header size="sm">{title}</Header>
          <Paragraph size="sm">{subTitle}</Paragraph>
        </Div>
      </Div>
      <PlanPrice
        price={price}
        discountedPrice={discountedPrice}
        isActive={isActive}
        expanded={expanded}
      />
    </Div>
  );
};

export default PlanCardHeader;
